// agriflow/products/static/js/module/AddStock.js


import FetchHandler from '../../../../assets/js/assets/FetchHandler';
import AlertHandler from "../../../../assets/js/modules/alertHandler";

import { Modal } from 'bootstrap';

export default class AddStock {
  constructor() {
    this.addStockButton = document.querySelector('#add-stock-button');
    this.modalElement = document.getElementById('addStockModal');
    if (!this.addStockButton || !this.modalElement) return;
    if (this.modalElement.parentElement !== document.body) {
        document.body.appendChild(this.modalElement);
    }
    this.modalElement.style.zIndex = '2060';

    this.modal = new Modal(this.modalElement, {
        backdrop: true,
        keyboard: true,
        focus: true
    });

    this.init();
  }

  init() {
    this.addStockButton.addEventListener('click', () => {
        const form = document.getElementById('addStockForm');
        if (form) form.reset();

        const productUnit = this.addStockButton.getAttribute('data-product-unit');
        const unitDisplay = document.getElementById('product-unit-display');
        if (unitDisplay && productUnit) {
            unitDisplay.textContent = `(${productUnit})`;
        }
        this.modal.show();
    });

    const createNewBatchBtn = document.getElementById('createNewBatchBtn');
    if (createNewBatchBtn) {
        createNewBatchBtn.addEventListener('click', () => this.createNewBatch());
    }
    
    const confirmBtn = document.getElementById('confirmAddStock');
    if (confirmBtn) {
        confirmBtn.addEventListener('click', () => this.handleSubmit());
    }

    this.loadStorageLocations();
    this.loadBatchNumbers();
  }

  async loadStorageLocations() {
    try {
      const response = await FetchHandler.getData('/api/warehouse_new/storage-nodes/?archive=false');
      const data = await response.json();
      
      const select = document.getElementById('storage_location');
      select.innerHTML = '<option value="">Bitte auswählen...</option>';
      
      if (Array.isArray(data)) {
          data.forEach(location => {
              const option = document.createElement('option');
              option.value = location.id;
              option.textContent = location.name;
              select.appendChild(option);
          });
      }

      $(select).select2({
        width: '100%',
        placeholder: 'Bitte auswählen',
        allowClear: true,
        dropdownParent: $('#addStockModal')
      });
    } catch (error) {
        console.error('Fehler beim Laden der Lagerplätze:', error);
    }
  }


  async loadBatchNumbers() {
    try {
        const response = await FetchHandler.getData(`/api/products/batch/`);
        const data = await response.json();
        
        const select = document.getElementById('batch_number');
        select.innerHTML = '<option value="">Keine Charge</option>';
        
        if (data.results) {
            data.results.forEach(batch => {
                const option = document.createElement('option');
                option.value = batch.id;
                option.textContent = batch.batch_number;
                select.appendChild(option);
            });
        }

        $(select).select2({
          width: '100%',
          placeholder: 'Keine Charge',
          allowClear: true,
          dropdownParent: $('#addStockModal')
        });
      } catch (error) {
          console.error('Fehler beim Laden der Chargen:', error);
      }
    }



    async createNewBatch() {
      const note = document.getElementById('batch_note').value.trim();
 
      try {
          const numberResponse = await fetch(`${getNextNumber}?modal=BAT`, {
            method: 'GET',
            headers: {
                'Authorization': `Token ${localStorage.getItem('token')}`
            }
        });
          
          const numberData = await numberResponse.json();
          
          if (!numberData.formatted_number) {
              AlertHandler.showAlert('Fehler: Keine Nummer verfügbar', 'danger');
              return;
          }
          
          const response = await fetch('/api/products/batch/', {
              method: 'POST',
              headers: {
                  'Content-Type': 'application/json',
                  'X-CSRFToken': document.querySelector('[name=csrfmiddlewaretoken]')?.value || ''
              },
              body: JSON.stringify({
                  batch_number: numberData.formatted_number,
                  notes: note || ''
              })
          });
          
          if (!response.ok) {
              const errorData = await response.json();
              console.error('API Fehler:', errorData);
              AlertHandler.showAlert('Fehler beim Erstellen: ' + JSON.stringify(errorData), 'danger');
              return;
          }
          
          const data = await response.json();
          
          if (data.id && data.batch_number) {
              const select = document.getElementById('batch_number');
              const option = document.createElement('option');
              option.value = data.id;
              option.textContent = data.batch_number;
              option.selected = true;
              select.appendChild(option);
              
              $(select).trigger('change');
              
              AlertHandler.showAlert('Neue Chargennummer: ' + data.batch_number, 'success');
              document.getElementById('batch_note').value = '';
          }
      } catch (error) {
          console.error('Fehler beim Erstellen:', error);
          AlertHandler.showAlert('Fehler beim Erstellen der Chargennummer: ' + error.message, 'danger');
      }
  }



  async handleSubmit() {
    const quantity = document.getElementById('quantity').value;
    const storageLocation = document.getElementById('storage_location').value;
    const batchNumber = document.getElementById('batch_number').value;
    
    const productId = this.addStockButton.getAttribute('data-product-id');
    
    if (!quantity || !storageLocation) {
        AlertHandler.showAlert('Bitte Menge und Lagerplatz ausfüllen!', 'danger');
        return;
    }
    
    try {
      const response = await fetch(`/api/products/detail/${productId}/add-stock/`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRFToken': document.querySelector('[name=csrfmiddlewaretoken]')?.value || ''
            },
            body: JSON.stringify({
                quantity: quantity,
                storage_location_id: storageLocation,
                batch_number_id: batchNumber || null
            })
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            console.error('API Fehler:', errorData);
            AlertHandler.showAlert('Fehler beim Speichern: ' + JSON.stringify(errorData), 'danger');
            return;
        }
        const data = await response.json();
        AlertHandler.showAlert('Wareneingang erfolgreich gespeichert!', 'success');
        const form = document.getElementById('addStockForm');
        if (form) form.reset();
        this.modal.hide();
        location.reload();
    } catch (error) {
        console.error('Fehler beim Speichern:', error);
        AlertHandler.showAlert('Fehler beim Speichern des Wareneingangs: ' + error.message, 'danger');
    }
}




}